export const CONTRIBUTORS_COMMENTS_PER_PAGE = 20;
